<template>
  <div class="pc-list" ref="list">
    <BaseSearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteBaseInit">删除</button>
          <span></span>
          <button @click="addBase">添加</button>
          <!-- <span></span>
          <button @click="exportBase">导出数据</button> -->
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="baseList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="baseList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
                  <el-table-column label="图片" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.cover_image" class="eltable-img">
            <img :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>
              <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        sortable="custom"
        width="100"
      ></el-table-column>

      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="基地名称"
        sortable="custom"
        width="180"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>
            <el-table-column prop="organization_id" label="组织" width="150" fixed="left">
        <template slot-scope="scope">
          <div>
            {{scope.row.organization_id}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop=" lng&&lat" label="经纬度" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.lng&&scope.row.lat">
            Lng{{ scope.row.lng }}Lat{{ scope.row.lat }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="150">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="baseDialog"
      :title="BaseDetail.chinese_name"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="图片">
          <UploadImage
            :img="BaseDetail.profile_image"
            :width="200"
            :height="160"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="职位">
          <el-input v-model="BaseDetail.title" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="中文名">
          <el-input
            v-model="BaseDetail.chinese_name"
            placeholder="请输入中文名"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="英文名">
          <el-input
            v-model="BaseDetail.english_name"
            placeholder="请输入英文名"
          ></el-input>
        </el-form-item>
        <el-form-item label="中文简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="BaseDetail.chinese_introduce"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="BaseDetail.english_introduce"
          ></el-input>
        </el-form-item>
        <el-switch
          v-model="BaseDetail.status"
          active-color="#91CC75"
          inactive-color="#C7C7C7"
          :active-value="1"
          :inactive-value="0"
          style="margin-left: 40px"
        >
        </el-switch>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(BaseDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="baseList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <!-- @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage" -->
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import BaseSearch from "./BaseSearch";
import DeleteHint from "@/components/template/DeleteHint";
import UploadImage from "../../../componentSet/uploadImage.vue";
import {
  getBaseList_Api,
  updateBaseDetail_Api,
  deleteBaseList_Api,
  getBaseDetail_Api,
  setBaseDetail_Api,
  //   outputBase_Api
} from "@/apis/exhibition.api";
export default {
  components: {
    UploadImage,
    BaseSearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      BaseDetail: {
        profile_image: "",
        base_id: null,
        status:0,
      },
      isSelectAll: false,
      baseList: [],
      checked: [],
    };
  },
  mounted() {
    this.getBaseListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getBaseListByRules(data) {
      this.loading = true;
      getBaseList_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.baseList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.checked = [];
        this.baseList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.baseList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getBaseListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/baseDetail",
        query: { id: item.id, method: "update" },
        name: "baseDetail",
        params: item,
      });
      window.open(route.href, "_blank");
    },

    // 修改状态
    changeState(row) {
      updateBaseDetail_Api({ base_id: row.id, status: row.status })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getBaseListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.name_keyword) {
        data.name_keyword = formData.name_keyword;
      }
      if (formData.organization_id) {
        data.organization_id = formData.organization_id;
      }
      return data;
    },
    isDelete() {
      let delete_ids = { base_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteBaseList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getBaseListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    // 删除设计师
    deleteBaseInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的基地！", null);
      }
    },
    // 添加设计师
    addBase() {
      let route = this.$router.resolve({
        path: "/admin/baseDetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    getUploadImage(img_url) {
      this.BaseDetail.profile_image = img_url;
    },
    submitBanner(item) {
      if (this.BaseDetail.id == null) {
        setBaseDetail_Api(this.BaseDetail).then((res) => {
          console.log(res);
          this.getBaseListByRules();  
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        updateBaseDetail_Api(this.BaseDetail).then((res) => {
          this.getBaseListByRules();
          console.log(res);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },
    // 到出数据
    // exportBase() {
    //   if (this.checked.length > 0) {
    //     outputBase_Api({base_id_list: this.checked }).then(
    //       (res) => {
    //         this.$global.downloadFile(res, "baseList");
    //       }
    //     );
    //   } else {
    //     this.$global.error(this, "请先勾选要导出的项目！", null);
    //   }
    // },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getBaseListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-dialog{
    width: 40% !important
}
/deep/ .el-upload__tip{
    margin-top: -10px
}
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/exhibition/component/BaseTable.vue